import { LOCATION_CHANGE } from 'connected-react-router';
import { match } from '@shared/utils/match';
import { createMiddleware } from '@shared/redux';
import gaTrackerEvent from '@shared/utils/analyticsTracker';
import * as AuthService from '../auth-service';
import {
    setSignUpStep,
} from '../sign-up/sign-up-state';
import { redirectToHome } from '../auth-base-state';
import { ROUTES } from '../auth.constants';


const trackSignUpEvent = () => AuthService.currentAuthenticatedUser()
    .then(() => redirectToHome())
    .catch(() => [
        gaTrackerEvent(
            'AuthSignUpSinglePage',
            'LocationChange',
        ),
        setSignUpStep({ step: 'sign-up-single-page' }),
    ]);

export const signUpSinglePageMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [ROUTES.SIGN_UP]: () => trackSignUpEvent(),
        [ROUTES.SIGN_UP_SINGLE_PAGE]: () => trackSignUpEvent(),
    }),
});
